module.exports = __webpack_public_path__ + "static/media/icon_directory.69f0d68a.svg";